/**
 * Created by JasonChou on 16/12/21.
 */
import http from '../libs/http'

export const getApps = (project_id, type) => {
  return http.get({
    url: '/api/project/apps',
    data: {
      params: {
        project_id,
        type
      }
    }
  }).then((res) => {
    return res;
  });
};

export const previewApp = (_id, project_id, page_id, secureStatic, isUpdatePreview) => {
  const mode = localStorage.getItem('DEV_MODE');
  const data = { app_id: _id, project_id, page_id, secureStatic, mode, isUpdatePreview };
  return http.put({
    url: '/api/app/preview',
    data
  }).then((res) => {
    return res;
  });
};

export const previewPage = (_id, project_id, page_id, restart = false, secureStatic = false) => {
  const data = { app_id: _id, project_id, page_id, restart, secureStatic };
  return http.post({
    url: '/api/app/previewPage',
    data
  }).then((res) => {
    return res;
  });
};

export const publishApp = (_id, project_id) => {
  const data = { app_id: _id, project_id };

  return http.post({
    url: '/api/app/deploy',
    data
  }).then((res) => {
    return res;
  });
};

export const multiPublishApp = (_id, project_id, environment) => {
  const data = { app_id: _id, project_id, environment };
  if (environment == "prod") {
    return http.post({
      url: '/api/app/prodDeploy',
      data
    }).then((res) => {
      return res;
    });
  } else {
    return http.post({
      url: '/api/app/multiDeploy',
      data
    }).then((res) => {
      return res;
    });
  }
};

export const modifyMultiPublishApp = (_id, operation, environment) => {
  const data = { app_id: _id, operation, environment };

  return http.put({
    url: '/api/app/multiDeploy',
    data
  }).then((res) => {
    return res;
  });
};

export const deployApp = (_id, project_id, version, desc, domain, persistence) => {
  const data = { app_id: _id, project_id, version, desc, domain, persistence };

  return http.post({
    url: '/api/app/deploy',
    data,
  }).then((res) => {
    return res;
  });
};

export const privateDeployApp = (_id, setting, preview) => {
  return http.post({
    url: '/api/app/privateDeploy',
    data: {
      _id,
      setting,
      preview,
    }
  }).then((res) => {
    return res;
  });
};

export const changeAppStatus = (_id, status) => {
  return http.post({
    url: '/api/app/deployStatus',
    data: {
      _id,
      status
    }
  }).then(res => {
    return res;
  });
};

export const deleteDeployAPP = (_id, app_id) => {
  return http.delete({
    url: '/api/app/deploy',
    data: {
      params: {
        _id,
        app_id
      }
    }
  }).then((res) => {
    return res;
  });
};

export const modifyDeployApp = (_id, app_id, domain, version, desc, persistence) => {
  return http.put({
    url: '/api/app/deploy',
    data: {
      _id,
      app_id,
      domain,
      version,
      desc,
      persistence,
    }
  }).then((res) => {
    return res;
  });
};

export const getAppDeployInfos = (app_id) => {
  return http.get({
    url: '/api/app/deploy',
    data: {
      params: {
        app_id
      }
    }
  }).then((res) => {
    return res;
  })
};

export const removeApp = (_id) => {
  return http.delete({
    url: '/api/app/',
    data: {
      params: {
        _id,
      }
    }
  }).then((res) => {
    return res;
  });
};

export const cloneApp = (_id) => {
  return http.post({
    url: '/api/app/clone',
    data: {
      _id,
    }
  }).then((res) => {
    return res;
  });
};

export const cloneAppToWeb = (app_id) => {
  return http.post({
    url: '/api/app/cloneWeb',
    data: {
      app_id,
    }
  }).then((res) => {
    return res;
  });
};

export const translateWeb = (app_id, pageChosenInfo) => {
  return http.put({
    url: '/api/app/cloneWeb',
    data: {
      app_id,
      pageChosenInfo
    }
  }).then((res) => {
    return res;
  });
};

export const newApp = ({
  template_id,
  project_id,
  project_domain,
  name,
  domain,
  keywords,
  type,
  desc,
  wxAppKey,
  wxAppSecret,
  component_appid,
  component_appsecret,
  miniProgramFileName,
  miniProgramContent,
  amapWeatherApiKey,
  miniProgramAppid,
  miniProgramAppSecret,
  miniProgramCorpId,
  miniProgramProviderSecret,
  miniProgramCorpSecret,
  suite_id,
  suite_secret,
  qy_token,
  aeskey,
  wxAppKeyPay,
  wxAppSecretPay,
  forMainSite,
  checkSelfBack,
  csrf
}) => {
  return http.post({
    url: '/api/app/',
    data: {
      name,
      template_id,
      domain,
      keywords,
      project_id,
      project_domain,
      desc,
      type,
      wxAppKey,
      wxAppSecret,
      component_appid,
      component_appsecret,
      miniProgramFileName,
      miniProgramContent,
      amapWeatherApiKey,
      miniProgramAppid,
      miniProgramAppSecret,
      miniProgramCorpId,
      miniProgramProviderSecret,
      miniProgramCorpSecret,
      suite_id,
      suite_secret,
      qy_token,
      aeskey,
      wxAppKeyPay,
      wxAppSecretPay,
      forMainSite,
      checkSelfBack,
      csrf
    }
  }).then((res) => {
    return res;
  });
};

export const updateApp = (data) => {
  return http.put({
    url: '/api/app/',
    data,
  }).then((res) => {
    return res;
  });
};

export const newTemp = ({
  _id,
  name,
  desc,
}) => {
  return http.post({
    url: '/api/template/',
    data: {
      _id,
      name,
      desc,
    }
  }).then((res) => {
    return res;
  });
};

export const getEditorInfo = (app_id, page_id) => {
  const mode = localStorage.getItem('DEV_MODE');
  return http.get({
    url: '/api/control/controls',
    data: {
      params: {
        app_id,
        page_id,
        mode
      }
    }
  }).then((res) => {
    return res;
  });
};
export const getEditorFlow = (id) => {
  const mode = localStorage.getItem('DEV_MODE');
  return http.get({
    url: '/api/flow',
    data: {
      params: {
        id
      }
    }
  }).then((res) => {
    return res;
  });
};

export const getAppManagementList = (app_id) => {
  return http.get({
    url: '/api/app/app_version_managements',
    data: {
      params: {
        app_id,
      }
    }
  }).then((res) => {
    return res;
  })
};

export const appManagementAccessFiled = (params) => {
  return http.post({
    url: '/api/app/app_version_management',
    data: {
      params
    }
  });
};

export const deleteAppManagement = (app_id, _id) => {
  return http.delete({
    url: '/api/app/app_version_management',
    data: {
      params: {
        app_id,
        _id
      }
    }
  });
};

export const changeMembers = (app_id, members) => {
  return http.post({
    url: '/api/member/app',
    data: {
      app_id,
      members,
    }
  }).then((res) => {
    return res;
  })
};

export const getMemberInfos = (app_id) => {
  return http.get({
    url: '/api/member/app',
    data: {
      params: { app_id }
    }
  }).then((res) => {
    return res;
  })
};

export const changeAppDomainCorrespondence = (app_id, domain_correspondence) => {
  return http.put({
    url: '/api/app/domain_correspondence',
    data: {
      app_id,
      domain_correspondence,
    }
  }).then((res) => {
    return res;
  })
};

export const seoSetting = (app_id, keywords, desc) => {
  return http.put({
    url: '/api/app/seo_setting/',
    data: {
      app_id,
      keywords,
      desc
    }
  }).then((res) => {
    return res;
  });
};

export const countSetting = (app_id, baidu, google) => {
  return http.put({
    url: '/api/app/count_setting/',
    data: {
      app_id,
      baidu,
      google
    }
  }).then((res) => {
    return res;
  });
};

export const updateAppPlugins = (app_id, plugins) => {
  return http.put({
    url: '/api/app/plugins/',
    data: {
      app_id,
      plugins
    }
  }).then((res) => {
    return res;
  });
}

export const updateAppEasyAnalysis = (app_id, analysis) => {
  return http.put({
    url: '/api/app/easy_analysis/',
    data: {
      app_id,
      analysis
    }
  }).then((res) => {
    return res;
  });
}

export const updateAppOssSetting = (appId, ossSetting) => {
  return http.put({
    url: '/api/app/ossSetting/',
    data: {
      appId,
      ossSetting,
    }
  }).then((res) => {
    return res;
  });
}

export const updateAppAntiKidnapping = (app_id, antiKidnapping) => {
  return http.put({
    url: '/api/app/anti_kidnapping/',
    data: {
      app_id,
      antiKidnapping
    }
  }).then((res) => {
    return res;
  });
}

export const getAppSetting = ({ _id, setting, type }) => { //type: 配置类型
  return http.put({
    url: '/api/app/app_setting',
    data: {
      _id,
      setting,
      type

    }
  }).then((res) => {
    return res;
  });
}

export const getThirdAPIHosts = (app_id) => {
  return http.get({
    url: '/api/app/app_thirdAPI_hosts/',
    data: {
      params: { app_id }
    }
  }).then((res) => {
    return res;
  });
}

export const updateThirdAPIHosts = (thirdAPIHosts) => {
  return http.put({
    url: '/api/app/app_thirdAPI_hosts/',
    data: {
      thirdAPIHosts
    }
  }).then((res) => {
    return res;
  });
}

export const deleteThirdAPIHosts = (app_id, _id) => {
  return http.delete({
    url: '/api/app/app_thirdAPI_hosts/',
    data: {
      params: {
        app_id,
        _id
      }
    }
  }).then((res) => {
    return res;
  });
};

export const updateAppDeployIps = (app_id, deployIps) => {
  return http.put({
    url: '/api/app/app_deploy_ips/',
    data: {
      app_id,
      deployIps
    }
  }).then((res) => {
    return res;
  });
};


export const getAppGlobalVariables = (app_id) => {
  return http.get({
    url: '/api/app/globalVariables',
    data: {
      params: {
        appId: app_id,
      }
    }
  }).then((res) => {
    return res;
  });
}
export const getAppCrons = (app_id) => {
  return http.get({
    url: '/api/app/AppCrons',
    data: {
      params: {
        appId: app_id,
      }
    }
  }).then((res) => {
    return res;
  });
}
export const updateOssTokenSetting = (app_id, ossTokenSetting) => {
  return http.put({
    url: '/api/app/appOssToken/',
    data: {
      app_id,
      ossTokenSetting
    }
  }).then((res) => {
    return res;
  });
}

export const updateSessionSetting = (app_id, sessionSetting) => {
  return http.put({
    url: '/api/app/appSession/',
    data: {
      app_id,
      sessionSetting
    }
  }).then((res) => {
    return res;
  });
}

export const getPageSubLayoutList = (app_id, page_id) => {
  return http.get({
    url: '/api/control/control_layout_list',
    data: {
      params: {
        app_id,
        page_id
      }
    }
  }).then((res) => {
    return res;
  });
};



// WEBPACK FOOTER //
// ./src/apis/app_api.js